import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './TeamSection.css';

// Import images
import mazinImg from '../../assets/images/team/mazin2.jpg';
import tareqImg from '../../assets/images/team/tareq.jpg';
import hakamImg from '../../assets/images/team/hakam.jpg';
import aidaImg from '../../assets/images/team/aida.jpg';
import bayanImg from '../../assets/images/team/bayan.jpg';
import ghaidaImg from '../../assets/images/team/ghaida.jpg';
import hiyamImg from '../../assets/images/team/hiyam.jpg';
import dialaImg from '../../assets/images/team/diala.jpg';
import kareemImg from '../../assets/images/team/kareem.jpg';
import samiImg from '../../assets/images/team/sami.jpg';
import majdiImg from '../../assets/images/team/majdi.jpg';
// Import LinkedIn icon SVG
const LinkedInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className="linkedin-icon"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.454C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/>
  </svg>
);

// Team members data with imported images
const teamMembers = [
  {
    nameEn: "Mazin Safadi",
    img: mazinImg,
    nameAr: "مازن صفدي",
    titleEn: "Founder & Managing Director - AI Innovation Strategist",
    titleAr: "مؤسس ومدير تنفيذي - مطور استراتيجيات الابتكار في الذكاء الاصطناعي",
    bioEn: "An engineer with over two decades of experience crafting digital excellence at leading global companies. Mazin transforms complex challenges into innovative solutions, transcending the boundaries of artificial environments while guiding the next generation of innovators. His leadership philosophy: Technology should empower humans, not replace them.",
    bioAr: "مهندس يمتلك خبرة تتجاوز العقدين في صياغة التميز الرقمي في كبرى الشركات العالمية. يحول مازن التحديات المعقدة إلى حلول مبتكرة، متجاوزاً حدود البيئة المصطنعة, مع توجيه الجيل القادم من المبدعين. فلسفته في القيادة: التكنولوجيا يجب أن تمكّن البشر، لا أن تحل محلهم.",
    linkedin: "https://www.linkedin.com/in/mazinsafadi/"
  },
     {
       nameEn: "Sami Karaeen",
       img: samiImg,
       nameAr: "سامي قراعين",
       titleEn: "Technology Expert & Product Manager | Software Architect",
       titleAr: "خبير تكنولوجيا ومدير منتجات | مهندس برمجيات",
       bioEn: "Technology Expert and Product Manager specializing in software architecture and enterprise solutions. Sami drives digital transformation and builds high-performing teams. Expert in programming, professional development, and talent building, he bridges complex technical concepts with practical applications, empowering teams to leverage cutting-edge technologies.",
       bioAr: "خبير تقنية ومدير منتجات متخصص في بنية البرمجيات والحلول المؤسسية. يقود سامي التحول الرقمي ويبني فرق عمل عالية الأداء. كخبير في البرمجة والتطوير المهني وبناء الكفاءات، يربط بين المفاهيم التقنية المعقدة والتطبيقات العملية، ممكّناً الفرق من الاستفادة من التقنيات المتطورة.",
       linkedin: "https://www.linkedin.com/in/sami-karaeen-it/"
     },
     {
       nameEn: "Majdi Haj Khalil",
       img: majdiImg,
       nameAr: "مجدي حاج خليل",
       titleEn: "Strategic Partnerships & Business Development Expert",
       titleAr: "خبير الشراكات الاستراتيجية وتطوير الأعمال",
       bioEn: "With over two decades of leadership in trade facilitation and economic development across MENA and international markets, Majdi brings deep expertise in building strategic partnerships and institutional frameworks. His extensive collaboration with major international organizations (EU, GIZ, UNDP, USAID) positions him to drive AI Academy's expansion across regional markets and establish key partnerships with government entities and international institutions.",
       bioAr: "مع أكثر من عقدين من الخبرة القيادية في تسهيل التجارة والتنمية الاقتصادية عبر أسواق الشرق الأوسط وشمال أفريقيا والأسواق الدولية، يجلب مجدي خبرة عميقة في بناء الشراكات الاستراتيجية والأطر المؤسسية. تعاونه الواسع مع المنظمات الدولية الكبرى (الاتحاد الأوروبي، GIZ، برنامج الأمم المتحدة الإنمائي، USAID) يؤهله لقيادة توسع أكاديمية الذكاء الاصطناعي عبر الأسواق الإقليمية وإقامة شراكات رئيسية مع الجهات الحكومية والمؤسسات الدولية.",
       linkedin: "https://www.linkedin.com/in/majdi-haj-khalil-msc-bsc-777b4318/"
     },
    {
     nameEn: "Diala Bayatneh",
     img: dialaImg,
     nameAr: "ديالا بياتنة",
     titleEn: "Business Development & PR Manager",
     titleAr: "مديرة تطوير الأعمال والعلاقات العامة",
     bioEn: "Computer Science and Marketing specialist with experience in education and curriculum development. She leads marketing efforts and strategic partnerships at the Academy, developing communication strategies to advance AI knowledge.",
     bioAr: "متخصصة في علوم الحاسوب والتسويق مع خبرة في التعليم وتطوير المناهج. تقود جهود التسويق والشراكات الاستراتيجية في الأكاديمية، وتطور استراتيجيات التواصل لتعزيز المعرفة في مجال الذكاء الاصطناعي.",
     linkedin: "https://www.linkedin.com/in/diala-bayatneh-205310273/"
    },
  {
    nameEn: "Tareq Khammash",
    img: tareqImg,
    nameAr: "طارق خمّاش",
    titleEn: "Energy Innovator & Entrepreneurship Specialist, MA & MBA",
    titleAr: "مبتكر في مجال الطاقة ومتخصص في ريادة الأعمال, لقب ثاني هندسة كهربائية وادارة اعمال",
    bioEn: "Bridging the gap between electrical engineering precision and entrepreneurial vision, Tareq combines analytical thinking with innovative problem-solving. His passion for sustainable technology drives his quest to develop solutions that are both commercially viable and environmentally responsible.",
    bioAr: "يجسر الفجوة بين دقة الهندسة الكهربائية ورؤية ريادة الأعمال، حيث يجمع طارق بين التفكير التحليلي وحل المشكلات بطرق مبتكرة. شغفه بالتكنولوجيا المستدامة يدفعه للبحث عن حلول قابلة للتطبيق تجارياً ومسؤولة بيئياً.",
    linkedin: "https://www.linkedin.com/in/tareqkhammash/"
  },
    {
     nameEn: "Hakam Nabulssi",
     img: hakamImg,
     nameAr: "حكم نابلسي",
     titleEn: "Programs Supervisor & Senior Programming Educator, MA AI",
     titleAr: "مشرف البرامج ومعلم برمجة متعدد اللغات, لقب ثاني بالذكاء الاصطناعي",
     bioEn: "A software polyglot fluent in multiple programming languages who believes in learning by doing. As Programs Supervisor, Hakam oversees curriculum development and educational quality while maintaining his passion for hands-on teaching. He transforms complex concepts into accessible knowledge, building bridges between theoretical foundations and practical implementation.",
     bioAr: "متعدد لغات البرمجة ويؤمن بالتعلم من خلال الممارسة. كمشرف البرامج، يشرف حكم على تطوير المناهج والجودة التعليمية مع الحفاظ على شغفه للتعليم التطبيقي. يحول المفاهيم المعقدة إلى معرفة سهلة المنال، ويبني جسوراً بين الأسس النظرية والتطبيق العملي.",
     linkedin: "https://www.linkedin.com/in/hakamnabulssi/"
    },
    {
      nameEn: "Bayan Zughaiar",
      img: bayanImg,
      nameAr: "بيان زغير",
      titleEn: "Software Architect & Education Innovator",
      titleAr: "مهندسة برمجيات ومبتكرة تعليمية",
      bioEn: "A computational thinker who brings academic rigor to software development. Bayan's dual talents in coding and teaching create a unique synergy – building robust systems while empowering others with the knowledge to do the same. Her methodical approach to problem-solving yields solutions that are both elegant and enduring.",
      bioAr: "مفكرة حاسوبية تضفي الدقة الأكاديمية على تطوير البرمجيات. مواهب بيان المزدوجة في البرمجة والتدريس تخلق مزيجاً فريداً - بناء أنظمة قوية مع تمكين الآخرين بالمعرفة للقيام بالمثل. نهجها المنهجي في حل المشكلات ينتج حلولاً أنيقة ودائمة.",
      linkedin: "https://www.linkedin.com/in/bayan-zughaiar-b761b919a/"
    },
    {
      nameEn: "Aida Qunbar",
      img: aidaImg,
      nameAr: "عايدة قنبر",
      titleEn: "Emerging Tech & Robotics Engineer",
      titleAr: "مهندسة تقنيات ناشئة وروبوتات",
      bioEn: "Where electronic design meets creative problem-solving, Aida thrives on bringing theoretical concepts to life. Her hands-on approach to circuit design and robotics programming represents the perfect blend of analytical thinking and innovative application. A rising star with the technical foundation to build tomorrow's solutions.",
      bioAr: "حيث يلتقي التصميم الإلكتروني بحل المشكلات الإبداعي، تزدهر عايدة في إحياء المفاهيم النظرية. يمثل نهجها العملي في تصميم الدوائر وبرمجة الروبوتات المزيج المثالي بين التفكير التحليلي والتطبيق المبتكر. نجمة صاعدة تمتلك الأساس التقني لبناء حلول الغد.",
      linkedin: "https://www.linkedin.com/in/aida-qunbar-3b2841219/"
    },
    {
           nameEn: "Hiyam Arar",
           img: hiyamImg,
           nameAr: "هيام عرار",
           titleEn: "Electrical Engineer and Entrepreneur",
           titleAr: "مهندسة كهرباء ومبتكرة ",
           bioEn: "Hiyam is an electrical engineer with hands-on experience in physical design, hardware verification, and facility management. She is passionate about empowering youth with logical and critical thinking skills and skilled in Linux environments, EDA tools, and SystemVerilog. Hiyam combines technical depth with a drive to make technology accessible and impactful.",
           bioAr: "هيام مهندسة كهرباء ذات خبرة عملية في التصميم الفيزيائي والتحقق من الموارد وإدارة المرافق. شغوفة بتمكين الشباب من مهارات التفكير المنطقي والناقد، ومتمرسة في بيئات LINUX وأدوات التصميم الإلكتروني ولغة SystemVerilog. تجمع بين العمق التقني والرغبة في جعل التكنولوجيا مفيدة ومؤثرة.",
           linkedin: "https://www.linkedin.com/in/hiyam-arar-520734167/"
         },
   {
         nameEn: "Kareem Natsheh",
         img: kareemImg,
         nameAr: "كريم نتشة",
         titleEn: "Digital Design Engineer & STEAM Instructor",
         titleAr: "مهندس تصميم رقمي ومدرب STEAM",
         bioEn: "Double major in Electrical Engineering and Computer Science with expertise in digital design and computer architecture. As a STEAM instructor, Kareem guides students through hands-on electronics projects using Arduino and micro:bit, building critical thinking and problem-solving abilities through interactive experiments and real-world applications.",
         bioAr: "تخصص مزدوج في الهندسة الكهربائية وعلوم الحاسوب مع خبرة في التصميم الرقمي وهيكلة الأجهزة. كمدرب STEAM، يوجه كريم الطلاب عبر مشاريع إلكترونية عملية باستخدام Arduino وmicro:bit، ويبني التفكير النقدي وقدرات حل المشكلات من خلال التجارب التفاعلية والتطبيقات الواقعية.",
         linkedin: "https://www.linkedin.com/in/kareem-natsheh-849611226/"
       },
  {
    nameEn: "Ghaida Mashni",
    img: ghaidaImg,
    nameAr: "غيدا  مشني",
    titleEn: "Occupational Therapist & Rehabilitation Specialist",
    titleAr: "معالجة وظيفية ومتخصصة في إعادة التأهيل",
    bioEn: "With expertise in acute care interventions, Ghaida brings a human-centered approach to rehabilitation. Her work bridges physical, cognitive, and social development in diverse populations. As a certified occupational therapist who has passed the official Board Examination, she specializes in creating personalized therapeutic strategies that enhance quality of life and functional independence. Ghaida's cross-cultural competence enriches our interdisciplinary team with valuable insights on accessibility and inclusive learning environments.",
    bioAr: "بخبرتها المتميزة في التدخلات العلاجية الحادة، تقدم غايدا نهجًا يركز على الإنسان في مجال إعادة التأهيل. يربط عملها بين التطور الجسدي والإدراكي والاجتماعي في مجموعات متنوعة. كمعالجة مهنية معتمدة اجتازت امتحان المجلس الوزاري، تتخصص في إنشاء استراتيجيات علاجية مخصصة تعزز جودة الحياة والاستقلالية الوظيفية. تثري كفاءة غايدا عبر الثقافات فريقنا متعدد التخصصات برؤى قيمة حول إمكانية الوصول وبيئات التعلم الشاملة.",
    linkedin: "#"
  }
];

const TeamSection: React.FC = () => {
  const { language } = useLanguage();

  // Function to get the appropriate image or fallback
  const getImage = (memberImg: any) => {
    try {
      return memberImg ;
    } catch (error) {
      return '';
    }
  };

  return (
    <section id="team" className="team-section">
      <div className="team-container">
        <h2 className="section-title">
          <span className="ar-content">فريق الأكاديمية</span>
          <span className="en-content">Our Team</span>
        </h2>

        <div className="team-intro">
          <p className="ar-content">
            فريقنا المتميز من الخبراء والمتخصصين في الذكاء الاصطناعي وتطوير البرمجيات والعلوم الصحية والعلوم المعرفية، يشاركون خبراتهم لبناء جيل جديد من المبتكرين.
          </p>
          <p className="en-content">
            Our distinguished team of experts and specialists in artificial intelligence, software development, Health and Cognitive Science, sharing their expertise to build a new generation of innovators.
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member">
              <div className="member-image-container">
                <div className="member-image-wrapper">
                  <img
                    src={getImage(member.img)}
                    alt={language === 'ar' ? member.nameAr : member.nameEn}
                    onError={(e) => {
                      // Fallback image if member image not found
                    }}
                  />
                  <div className="image-overlay"></div>
                </div>

                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedin-link"
                  aria-label={`${member.nameEn} LinkedIn profile`}
                >
                  <LinkedInIcon />
                </a>
              </div>

              <div className="member-info">
                <h3 className="member-name">
                  <span className="ar-content">{member.nameAr}</span>
                  <span className="en-content">{member.nameEn}</span>
                </h3>
                <div className="member-title">
                  <span className="ar-content">{member.titleAr}</span>
                  <span className="en-content">{member.titleEn}</span>
                </div>
                <p className="member-bio">
                  <span className="ar-content">{member.bioAr}</span>
                  <span className="en-content">{member.bioEn}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;